import { useState, useEffect } from 'react'
import { CogIcon } from '@heroicons/react/outline'
import { useNavigate, Outlet } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

import Link from '@/components/Link'

export default function Settings() {
  const router = useNavigate()
  const [selected, setSelected] = useState(null)
  const [title, setTitle] = useState('Settings')
  useEffect(() => {
    if (window.location.pathname == '/settings') {
      router('/settings/general')
    }
    switch (window.location.pathname) {
      case '/settings/general':
        setSelected(0)
        setTitle('General Settings')
        break;
      case '/settings/security':
        setSelected(1)
        setTitle('Security')
        break;
      case '/settings/preferences':
        setSelected(2)
        setTitle('Preferences')
        break;
      // case '/settings/ignored':
      //   setSelected(3)
      //   setTitle('Ignored Users')
      //   break;
      // case '/settings/offers':
      //   setSelected(4)
      //   setTitle('Offers')
      //   break;
      default:
        setSelected(0)
        setTitle('Settings')
        break;
    }
  }, [window.location.pathname])

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className="py-8 container relative h-full">
        <h1 className="flex items-center mb-4 text-lg font-medium">
          Settings
        </h1>
        <div className="flex flex-col md:flex-row">
          <div className="hidden md:block relative">
            <aside className="w-48 bg-gray-900 text-sm rounded-md font-medium relative overflow-hidden sticky top-4">
              <ul className="">
                <li onClick={() => setSelected(0)}>
                  <Link className="hover:bg-gray-700 p-2 block border-l-4 transition-all duration-300 flex border-transparent" activeClassName="bg-gray-700" to="/settings/general"><span>General</span></Link>
                </li>
                <li onClick={() => setSelected(1)}>
                  <Link className="hover:bg-gray-700 p-2 block border-l-4 transition-all duration-300 flex border-transparent" activeClassName="bg-gray-700" to="/settings/security"><span>Security</span></Link>
                </li>
                <li onClick={() => setSelected(2)}>
                  <Link className="hover:bg-gray-700 p-2 block border-l-4 transition-all duration-300 flex border-transparent" activeClassName="bg-gray-700" to="/settings/preferences"><span>Preferences</span></Link>
                </li>
                {/* <li onClick={() => setSelected(3)}>
                  <Link className="hover:bg-gray-700 p-2 block border-l-4 transition-all duration-300 flex border-transparent" activeClassName="bg-gray-700" to="/settings/ignored"><span>Ignored Users</span></Link>
                </li>
                <li onClick={() => setSelected(4)}>
                  <Link className="hover:bg-gray-700 p-2 block border-l-4 transition-all duration-300 flex border-transparent" activeClassName="bg-gray-700" to="/settings/offers"><span>Offers</span></Link>
                </li> */}
              </ul>
              {selected !== null && (
                <span className={`block absolute left-0 h-[36px] top-0 bg-purple-600 w-1 transform transition-all duration-300`} style={{ transform: `translateY(calc(100% * ${selected}))` }}></span>
              )}
            </aside>
          </div>
          <div className="md:hidden overflow-hidden mobile-subnav mb-3">
            <ul className="flex overflow-auto">
              <li className="flex-shrink-0">
                <Link className="rounded-full py-2 px-3 block transition-all duration-300 flex" activeClassName="bg-gray-700" to="/settings/general"><span>General</span></Link>
              </li>
              <li className="flex-shrink-0">
                <Link className="rounded-full py-2 px-3 block transition-all duration-300 flex" activeClassName="bg-gray-700" to="/settings/security"><span>Security</span></Link>
              </li>
              <li className="flex-shrink-0">
                <Link className="rounded-full py-2 px-3 block transition-all duration-300 flex" activeClassName="bg-gray-700" to="/settings/preferences"><span>Preferences</span></Link>
              </li>
              {/* <li className="flex-shrink-0">
                <Link className="rounded-full py-2 px-3 block transition-all duration-300 flex" activeClassName="bg-gray-700" to="/settings/ignored"><span>Ignored Users</span></Link>
              </li>
              <li className="flex-shrink-0">
                <Link className="rounded-full py-2 px-3 block transition-all duration-300 flex" activeClassName="bg-gray-700" to="/settings/offers"><span>Offers</span></Link>
              </li> */}
            </ul>
          </div>
          <div className="flex-1 md:pl-4">
            <div className="bg-gray-900 rounded-md p-4">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}